import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-relay_title",
  "use": "icon-relay_title-usage",
  "viewBox": "0 0 14.875 13.327",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.875 13.327\" id=\"icon-relay_title\">\n  <defs>\n  </defs>\n  <path id=\"icon-relay_title_平台\" class=\"cls-1\" d=\"M129.606,193.453v1.206H120v-1.206Zm2.6-12.121v10.051H117.334V181.333ZM131,182.539H118.54v7.639H131Zm-2.181,4.482v1.206h-8.041v-1.206Zm0-2.814v1.206h-8.041v-1.206Z\" transform=\"translate(-117.334 -181.333)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol